<div class="frame-in">
  <div class="items africa-1-frame">
    <svg class="road africa-1">
      <style type="text/css">
        tspan {
        white-space: pre
      }

      .shp0 {
      fill: none;
      stroke: #ffffff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 5;
      stroke-dasharray: 15,15
    }
  </style>
  <g id="GAME UI">
    <g id="ZONE 1">
      <g id="ZONE 1">
        <g id="Track lines ZONE1">
          <path id="Shape 2233" class="shp0" d="M388 22C388 22 454.89 34.58 474 19C488.65 7.05 535.05 3.59 559.69 3.52" />
          <path id="Shape 1363" class="shp0" d="M592 5C592 5 630.5 1.5 647 18" />
          <path id="Shape 1601" class="shp0" d="M336 18C336 18 271.13 8.06 229 26.07C182.76 45.84 166.57 141.74 217 175C241.11 190.9 316.31 197.82 392 194C467.69 190.18 520.12 215.26 519.71 277.92C519.38 328.21 445 331 445 331" />
          <path id="Shape 3937" class="shp0" d="M105.38 141.63C105.38 141.63 168.08 142.21 169.89 181.61C171.71 221.01 136.69 321.68 203.51 325.17C270.33 328.66 335 325.98 335 325.98" />
          <path id="Shape 1585" class="shp0" d="M114 0.02C96.18 10.15 -2.68 19.03 1 84C3.27 124.09 43.73 121.72 87 127" />
        </g>
      </g>
    </g>
  </g>
</svg>
<div class="country africa-1"></div>
<div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 8, 'active': quizLevel === 8 && tick2Quiz}"></div>

@for (zone of zones; track zone) {
  <div>
    <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
  </div>
}

@for (zone of zones; track zone; let i = $index) {
  <div
    class="poi {{zone.class}}"
    [ngClass]="{active: zone.active, 'lock': zone.locked}"
    (mouseenter)="mouseEnter(zone)"
    (mouseleave)="mouseLeave(zone)"
    (click)="selectZone(zone)">
    <span>{{ zone.locked ? '' : zone.number}}</span>
  </div>
}
</div>
</div>

<img class="frame-title" src="assets/images/zones/africa-1/title.png">

<audio id="introductionAudio" (ended)="playBgAudio()">
  <source src="assets/sounds/country.wav" type="audio/wav">
</audio>
<audio id="bgAudio" (ended)="playIntroductionAudio()">
  <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
</audio>

<div class="footer">
  <ul class="zone-menu">
    <li>
      @if (!haveAccess('3-1')) {
        <span class="lock"></span>
      }
      @if (haveAccess('3-1')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-1' ]" routerLinkActive="active">1</a>
      }
    </li>
    <li>
      @if (!haveAccess('3-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('3-2')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('3-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('3-3')) {
        <a class="menu-item" [routerLink]="[ '/game/africa-3' ]" routerLinkActive="active">3</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/africa-1/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
